import AuthToken from "@/models/authToken";

class AuthenticationService {
  saveAuthTokenToStorage(token: AuthToken): void {
    try {
      if (localStorage.getItem("rememberCheck")) {
        localStorage.setItem("auth_token", JSON.stringify(token));
      } else {
        sessionStorage.setItem("auth_token", JSON.stringify(token));
      }
    } catch (e) {
      console.log(e);
    }
  }

  getAuthTokenFromStorage(): AuthToken | null {
    try {
      if (localStorage.getItem("rememberCheck")) {
        const serializedState = localStorage.getItem("auth_token");
        if (serializedState === null) return null;
        return JSON.parse(serializedState) as AuthToken;
      } else {
        const serializedState = sessionStorage.getItem("auth_token");
        if (serializedState === null) return null;
        return JSON.parse(serializedState) as AuthToken;
      }
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  clearAuthTokenFromStorage(): void {
    try {
      if (localStorage.getItem("rememberCheck")) {
        localStorage.removeItem("auth_token");
      } else {
        sessionStorage.removeItem("auth_token");
      }
    } catch (e) {
      console.log(e);
    }
  }
}

export default AuthenticationService;
